module.exports = __webpack_public_path__ + "static/media/tokei.6f33b93e.png";